(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8142],{

/***/ 62812:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chain]/asset/[assetId]",
      function () {
        return __webpack_require__(19722);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 98745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ buttons_AddToCart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.module.js + 206 modules
var index_module = __webpack_require__(61897);
// EXTERNAL MODULE: ./components/primitives/index.ts + 15 modules
var primitives = __webpack_require__(92902);
// EXTERNAL MODULE: ./node_modules/@rainbow-me/rainbowkit/dist/chunk-3B7JRKV5.js + 15 modules
var chunk_3B7JRKV5 = __webpack_require__(87671);
// EXTERNAL MODULE: ./hooks/index.ts + 5 modules
var hooks = __webpack_require__(35430);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./context/ToastContextProvider.tsx + 4 modules
var ToastContextProvider = __webpack_require__(98045);
// EXTERNAL MODULE: ./components/primitives/Dialog.tsx
var Dialog = __webpack_require__(39114);
;// CONCATENATED MODULE: ./components/common/ConfirmationModal.tsx



const ConfirmationModal = (param)=>{
    let { title , message , confirmationText ="Continue" , open , onOpenChange , onConfirmed =()=>{}  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Dialog */.Vq, {
        open: open,
        onOpenChange: onOpenChange,
        overlayProps: {
            style: {
                opacity: 0.7
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            css: {
                p: 24,
                gap: "$2",
                background: "$gray2"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle1",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "body1",
                    color: "subtle",
                    children: message
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        gap: "$2",
                        mt: "$4"
                    },
                    justify: "end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                            color: "gray3",
                            size: "medium",
                            onClick: ()=>{
                                onConfirmed(true);
                                onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "subtitle2",
                                color: "error",
                                children: confirmationText
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                            size: "medium",
                            onClick: ()=>{
                                onConfirmed(false);
                                onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(false);
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "subtitle2",
                                css: {
                                    color: "inherit"
                                },
                                children: "Cancel"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/buttons/AddToCart.tsx











const AddToCart = (param)=>{
    let { token , orderId =undefined , buttonCss , buttonProps  } = param;
    var _token_market, _token_market_floorAsk, _token_market_floorAsk_price, _token_market1, _token_market_floorAsk1, _token_market_floorAsk_price1;
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const { data: items , add , remove , clear  } = (0,index_module/* useCart */.jD)((cart)=>cart.items);
    const { data: cartChain  } = (0,index_module/* useCart */.jD)((cart)=>cart.chain);
    const { isConnected  } = (0,dist/* useAccount */.mA)();
    const { openConnectModal  } = (0,chunk_3B7JRKV5/* useConnectModal */.We)();
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const [confirmationOpen, setConfirmationOpen] = (0,react.useState)(false);
    const hasOrderId = !!orderId;
    if (hasOrderId) {
        const orderIsInCart = items.find((item)=>{
            var _item_order;
            return ((_item_order = item.order) === null || _item_order === void 0 ? void 0 : _item_order.id) === orderId;
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                    css: buttonCss,
                    color: "primary",
                    onClick: async ()=>{
                        if (!isConnected) {
                            openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                        }
                        if (orderIsInCart) {
                            remove([
                                orderId
                            ]);
                        } else if (cartChain && (cartChain === null || cartChain === void 0 ? void 0 : cartChain.id) !== marketplaceChain.id) {
                            setConfirmationOpen(true);
                        } else {
                            add([
                                {
                                    orderId: orderId
                                }
                            ], marketplaceChain.id).then(()=>{
                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                    title: "Added to cart"
                                });
                            });
                        }
                    },
                    ...buttonProps,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: orderIsInCart ? free_solid_svg_icons/* faMinus */.Kl4 : free_solid_svg_icons/* faShoppingCart */.sq$,
                        width: "16",
                        height: "16"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationModal, {
                    title: "Could not add item to cart",
                    message: "Your cart has items from a different chain than the item you are trying to add. Adding this item will clear your existing cart and start a new one.",
                    open: confirmationOpen,
                    onOpenChange: setConfirmationOpen,
                    onConfirmed: (confirmed)=>{
                        if (confirmed) {
                            clear();
                            add([
                                {
                                    orderId: orderId
                                }
                            ], marketplaceChain.id);
                        }
                    }
                })
            ]
        });
    }
    if (!token || !("market" in token) && !("id" in token)) {
        return null;
    }
    if ("market" in token && ((token === null || token === void 0 ? void 0 : (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : (_token_market_floorAsk_price = _token_market_floorAsk.price) === null || _token_market_floorAsk_price === void 0 ? void 0 : _token_market_floorAsk_price.amount) === null || (token === null || token === void 0 ? void 0 : (_token_market1 = token.market) === null || _token_market1 === void 0 ? void 0 : (_token_market_floorAsk1 = _token_market1.floorAsk) === null || _token_market_floorAsk1 === void 0 ? void 0 : (_token_market_floorAsk_price1 = _token_market_floorAsk1.price) === null || _token_market_floorAsk_price1 === void 0 ? void 0 : _token_market_floorAsk_price1.amount) === undefined)) {
        return null;
    }
    let tokenKey = "";
    if ("id" in token) {
        tokenKey = token.id;
    } else {
        var _token_token, _token_token_collection, _token_token1;
        tokenKey = "".concat((_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_collection = _token_token.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.id, ":").concat((_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.tokenId);
    }
    const isInCart = items.find((item)=>"".concat(item.collection.id, ":").concat(item.token.id) === tokenKey);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                css: buttonCss,
                color: "primary",
                onClick: async ()=>{
                    if (!isConnected) {
                        openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                    }
                    if (isInCart) {
                        remove([
                            tokenKey
                        ]);
                    } else if (cartChain && (cartChain === null || cartChain === void 0 ? void 0 : cartChain.id) !== marketplaceChain.id) {
                        setConfirmationOpen(true);
                    } else {
                        add([
                            token
                        ], marketplaceChain.id).then(()=>{
                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                title: "Added to cart"
                            });
                        });
                    }
                },
                ...buttonProps,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: isInCart ? free_solid_svg_icons/* faMinus */.Kl4 : free_solid_svg_icons/* faShoppingCart */.sq$,
                    width: "16",
                    height: "16"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationModal, {
                title: "Could not add item to cart",
                message: "Your cart has items from a different chain than the item you are trying to add. Adding this item will clear your existing cart and start a new one.",
                open: confirmationOpen,
                onOpenChange: setConfirmationOpen,
                onConfirmed: (confirmed)=>{
                    if (confirmed) {
                        clear();
                        add([
                            token
                        ], marketplaceChain.id);
                    }
                }
            })
        ]
    });
};
/* harmony default export */ var buttons_AddToCart = (AddToCart);


/***/ }),

/***/ 61818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87671);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61897);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var _context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98045);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35430);







const CancelBid = (param)=>{
    let { bidId , openState , trigger , mutate  } = param;
    const { addToast  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext */ .u);
    const { openConnectModal  } = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__/* .useConnectModal */ .We)();
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMarketplaceChain */ .gw)();
    const { switchNetworkAsync  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useSwitchNetwork */ .g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWalletClient */ .py)();
    const { chain: activeChain  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useNetwork */ .LN)();
    const isInTheWrongNetwork = Boolean(signer && marketplaceChain.id !== (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id));
    if (isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelBidModal */ .BJ, {
        bidId: bidId,
        trigger: trigger,
        openState: openState,
        onCancelComplete: (data)=>{
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "User canceled bid",
                description: "You have canceled the bid."
            });
        },
        onCancelError: (error, data)=>{
            console.log("Bid Cancel Error", error, data);
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not cancel bid",
                description: "The transaction was not completed."
            });
        },
        onClose: (data, currentStep)=>{
            if (mutate && currentStep == _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelBidStep.Complete */ .JE.Complete) mutate();
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CancelBid);


/***/ }),

/***/ 41456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87671);
/* harmony import */ var _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61897);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69077);
/* harmony import */ var _context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98045);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35430);







const CancelListing = (param)=>{
    let { listingId , openState , trigger , mutate  } = param;
    const { addToast  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context_ToastContextProvider__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext */ .u);
    const { openConnectModal  } = (0,_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_4__/* .useConnectModal */ .We)();
    const marketplaceChain = (0,hooks__WEBPACK_IMPORTED_MODULE_3__/* .useMarketplaceChain */ .gw)();
    const { switchNetworkAsync  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useSwitchNetwork */ .g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useWalletClient */ .py)();
    const { chain: activeChain  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useNetwork */ .LN)();
    const isInTheWrongNetwork = Boolean(signer && activeChain && activeChain.id !== marketplaceChain.id);
    if (isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelListingModal */ .GO, {
        listingId: listingId,
        openState: openState,
        trigger: trigger,
        onCancelComplete: (data)=>{
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "User canceled listing",
                description: "You have canceled the listing."
            });
        },
        onCancelError: (error, data)=>{
            console.log("Listing Cancel Error", error, data);
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not cancel listing",
                description: "The transaction was not completed."
            });
        },
        onClose: (data, currentStep)=>{
            if (mutate && currentStep == _reservoir0x_reservoir_kit_ui__WEBPACK_IMPORTED_MODULE_6__/* .CancelListingStep.Complete */ .MD.Complete) mutate();
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CancelListing);


/***/ }),

/***/ 19722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _assetId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-tabs/dist/index.module.js + 1 modules
var index_module = __webpack_require__(79509);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.module.js + 206 modules
var dist_index_module = __webpack_require__(61897);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
// EXTERNAL MODULE: ./components/common/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(74431);
// EXTERNAL MODULE: ./components/common/MobileActivityFilters.tsx
var MobileActivityFilters = __webpack_require__(33808);
// EXTERNAL MODULE: ./components/common/OpenSeaVerified.tsx
var OpenSeaVerified = __webpack_require__(44930);
// EXTERNAL MODULE: ./components/primitives/index.ts + 15 modules
var primitives = __webpack_require__(92902);
// EXTERNAL MODULE: ./components/primitives/Dropdown.tsx
var Dropdown = __webpack_require__(12623);
// EXTERNAL MODULE: ./components/primitives/Tab.tsx
var Tab = __webpack_require__(53370);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-collapsible/dist/index.module.js + 1 modules
var react_collapsible_dist_index_module = __webpack_require__(20163);
// EXTERNAL MODULE: ./components/primitives/Collapsible.tsx
var Collapsible = __webpack_require__(61194);
;// CONCATENATED MODULE: ./components/token/ActivityFilters.tsx






const ActivityFilters = (param)=>{
    let { open , setOpen , activityTypes , activityNames , setActivityTypes , setActivityNames  } = param;
    const filters = [
        {
            type: "sale",
            name: "Sales",
            icon: free_solid_svg_icons/* faShoppingCart */.sq$
        },
        {
            type: "ask",
            name: "Listings",
            icon: free_solid_svg_icons/* faTag */.LEN
        },
        {
            type: "bid",
            name: "Offers",
            icon: free_solid_svg_icons/* faHand */.ioV
        },
        {
            type: "transfer",
            name: "Transfer",
            icon: free_solid_svg_icons/* faRightLeft */.eRx
        },
        {
            type: "mint",
            name: "Mint",
            icon: free_solid_svg_icons/* faSeedling */.YKZ
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_collapsible_dist_index_module/* Root */.fC, {
        open: open,
        onOpenChange: setOpen,
        style: {
            transition: "width .5s",
            width: open ? 320 : 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* CollapsibleContent */.Fw, {
            css: {
                position: "sticky",
                top: 16 + 80,
                height: "max-content",
                overflow: "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    "& > div:first-of-type": {
                        mt: "$2"
                    }
                },
                children: filters.map((filter)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            mb: "$3",
                            gap: "$3"
                        },
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    color: "$gray11"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: filter.icon,
                                    width: 16,
                                    height: 16
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body1",
                                css: {
                                    flex: 1
                                },
                                children: filter.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Switch */.rs, {
                                    checked: activityTypes === null || activityTypes === void 0 ? void 0 : activityTypes.includes(filter.type),
                                    onCheckedChange: (checked)=>{
                                        if (checked) {
                                            setActivityTypes([
                                                ...activityTypes,
                                                filter.type
                                            ]);
                                            setActivityNames([
                                                ...activityNames,
                                                filter.name
                                            ]);
                                        } else {
                                            setActivityNames(activityNames.filter((item)=>{
                                                return item != filter.name;
                                            }));
                                            setActivityTypes(activityTypes.filter((item)=>{
                                                return item != filter.type;
                                            }));
                                        }
                                    }
                                })
                            })
                        ]
                    }, filter.type);
                })
            })
        })
    }, "hi");
};

// EXTERNAL MODULE: ./hooks/index.ts + 5 modules
var hooks = __webpack_require__(35430);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/constants/address.js
var constants_address = __webpack_require__(66373);
;// CONCATENATED MODULE: ./components/token/ActivityTable.tsx












const TokenActivityTable = (param)=>{
    let { id , activityTypes  } = param;
    const data = (0,dist_index_module/* useTokenActivity */.oG)(id, {
        types: activityTypes
    }, {
        revalidateOnMount: true,
        fallbackData: []
    });
    (0,react.useEffect)(()=>{
        data.mutate();
        return ()=>{
            data.setSize(1);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityTable, {
        data: data
    });
};
const ActivityTable = (param)=>{
    let { data  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    const activities = data.data;
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            data.fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !data.isValidating && !data.isFetchingPage && activities && activities.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/icons/activity-icon.svg",
                        width: 40,
                        height: 40
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        children: "No activity yet"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    height: data.isLoading ? "225px" : "450px",
                    overflowY: "auto",
                    width: "100%",
                    pb: "$2",
                    pr: 15
                },
                children: [
                    activities.map((activity, i)=>{
                        if (!activity) return null;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityTableRow, {
                            activity: activity
                        }, "".concat(activity === null || activity === void 0 ? void 0 : activity.txHash, "-").concat(i));
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        ref: loadMoreRef,
                        css: {
                            height: 20
                        }
                    })
                ]
            }),
            data.isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$5"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            })
        ]
    });
};
const logos = {
    transfer: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faRightLeft */.eRx,
        width: 16,
        height: 16
    }),
    sale: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faShoppingCart */.sq$,
        width: 16,
        height: 16
    }),
    mint: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faSeedling */.YKZ,
        width: 16,
        height: 16
    }),
    burned: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faTrash */.$aW,
        width: 16,
        height: 16
    }),
    listing_canceled: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faXmark */.g82,
        width: 16,
        height: 16
    }),
    ask_cancel: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faXmark */.g82,
        width: 16,
        height: 16
    }),
    offer_canceled: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faXmark */.g82,
        width: 16,
        height: 16
    }),
    ask: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faTag */.LEN,
        width: 16,
        height: 16
    }),
    bid: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
        icon: free_solid_svg_icons/* faHand */.ioV,
        width: 16,
        height: 16
    })
};
const activityTypeToDesciptionMap = {
    ask_cancel: "Listing Canceled",
    bid_cancel: "Offer Canceled",
    mint: "Mint",
    ask: "List",
    bid: "Offer",
    transfer: "Transfer",
    sale: "Sale"
};
const activityTypeToDesciption = (activityType)=>{
    return activityTypeToDesciptionMap[activityType] || activityType;
};
const ActivityTableRow = (param)=>{
    let { activity  } = param;
    var _marketplaceChain_blockExplorers, _marketplaceChain_blockExplorers_default, _activity_price_amount, _activity_price_amount1, _activity_price_currency, _activity_order, _activity_order_source, _activity_order1, _activity_order_source1, _activity_order2, _activity_order_source2;
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 700
    });
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const blockExplorerBaseUrl = (marketplaceChain === null || marketplaceChain === void 0 ? void 0 : (_marketplaceChain_blockExplorers = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers === void 0 ? void 0 : (_marketplaceChain_blockExplorers_default = _marketplaceChain_blockExplorers.default) === null || _marketplaceChain_blockExplorers_default === void 0 ? void 0 : _marketplaceChain_blockExplorers_default.url) || "https://etherscan.io";
    if (!activity) {
        return null;
    }
    let activityDescription = activityTypeToDesciption((activity === null || activity === void 0 ? void 0 : activity.type) || "");
    const { displayName: toDisplayName  } = (0,hooks/* useENSResolver */.Af)(activity === null || activity === void 0 ? void 0 : activity.toAddress);
    const { displayName: fromDisplayName  } = (0,hooks/* useENSResolver */.Af)(activity === null || activity === void 0 ? void 0 : activity.fromAddress);
    if (isSmallDevice) {
        var _activity_price_amount2, _activity_price_amount3, _activity_price_currency1, _activity_order3, _activity_order_source3, _activity_order4, _activity_order_source4, _activity_order5, _activity_order_source5;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
            css: {
                gridTemplateColumns: "0.75fr 1fr"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                    css: {
                        color: "$gray11"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                children: [
                                    activity.type && logos[activity.type],
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle1",
                                        css: {
                                            ml: "$2",
                                            color: "$gray11",
                                            fontSize: "14px"
                                        },
                                        children: activityDescription
                                    })
                                ]
                            }),
                            activity.price && ((_activity_price_amount2 = activity.price.amount) === null || _activity_price_amount2 === void 0 ? void 0 : _activity_price_amount2.decimal) !== 0 && activity.type && activity.type !== "transfer" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                align: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    amount: (_activity_price_amount3 = activity.price.amount) === null || _activity_price_amount3 === void 0 ? void 0 : _activity_price_amount3.decimal,
                                    address: (_activity_price_currency1 = activity.price.currency) === null || _activity_price_currency1 === void 0 ? void 0 : _activity_price_currency1.contract,
                                    logoHeight: 16,
                                    textStyle: "subtitle1",
                                    css: {
                                        mr: "$2",
                                        fontSize: "14px"
                                    }
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "-"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                justify: "end",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    !!((_activity_order3 = activity.order) === null || _activity_order3 === void 0 ? void 0 : (_activity_order_source3 = _activity_order3.source) === null || _activity_order_source3 === void 0 ? void 0 : _activity_order_source3.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        width: "20px",
                                        height: "20px",
                                        src: ((_activity_order4 = activity.order) === null || _activity_order4 === void 0 ? void 0 : (_activity_order_source4 = _activity_order4.source) === null || _activity_order_source4 === void 0 ? void 0 : _activity_order_source4.icon) || "",
                                        alt: "".concat((_activity_order5 = activity.order) === null || _activity_order5 === void 0 ? void 0 : (_activity_order_source5 = _activity_order5.source) === null || _activity_order_source5 === void 0 ? void 0 : _activity_order_source5.name, " Source")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle3",
                                        color: "subtle",
                                        children: (0,hooks/* useTimeSince */.vS)(activity === null || activity === void 0 ? void 0 : activity.timestamp)
                                    }),
                                    activity.txHash && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                        href: "".concat(blockExplorerBaseUrl, "/tx/").concat(activity.txHash),
                                        color: "primary",
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons/* faExternalLink */.gJF,
                                            width: 12,
                                            height: 15
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "baseline",
                                justify: "end",
                                css: {
                                    gap: "$3"
                                },
                                children: [
                                    activity.fromAddress && activity.fromAddress !== constants_address/* zeroAddress */.D ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/portfolio/".concat(activity.fromAddress),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            css: {
                                                color: "$primary11",
                                                "&:hover": {
                                                    color: "$primary10"
                                                }
                                            },
                                            children: fromDisplayName
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle3",
                                        css: {
                                            fontSize: "12px",
                                            color: "$gray11"
                                        },
                                        children: "to"
                                    }),
                                    activity.toAddress && activity.toAddress !== constants_address/* zeroAddress */.D ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/portfolio/".concat(activity.toAddress),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle3",
                                            css: {
                                                color: "$primary11",
                                                "&:hover": {
                                                    color: "$primary10"
                                                }
                                            },
                                            children: toDisplayName
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "-"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        }, activity.txHash);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: "1fr 1fr"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                css: {
                    color: "$gray11"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            children: [
                                activity.type && logos[activity.type],
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle2",
                                    css: {
                                        ml: "$2"
                                    },
                                    color: "subtle",
                                    children: activityDescription
                                })
                            ]
                        }),
                        activity.price && ((_activity_price_amount = activity.price.amount) === null || _activity_price_amount === void 0 ? void 0 : _activity_price_amount.decimal) !== 0 && activity.type && activity.type !== "transfer" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            align: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                amount: (_activity_price_amount1 = activity.price.amount) === null || _activity_price_amount1 === void 0 ? void 0 : _activity_price_amount1.decimal,
                                address: (_activity_price_currency = activity.price.currency) === null || _activity_price_currency === void 0 ? void 0 : _activity_price_currency.contract,
                                logoHeight: 16,
                                textStyle: "subtitle1",
                                css: {
                                    mr: "$2",
                                    fontSize: "14px"
                                }
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "-"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* TableCell */.pj, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            justify: "end",
                            css: {
                                gap: "$3"
                            },
                            children: [
                                !!((_activity_order = activity.order) === null || _activity_order === void 0 ? void 0 : (_activity_order_source = _activity_order.source) === null || _activity_order_source === void 0 ? void 0 : _activity_order_source.icon) && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    width: "20px",
                                    height: "20px",
                                    src: ((_activity_order1 = activity.order) === null || _activity_order1 === void 0 ? void 0 : (_activity_order_source1 = _activity_order1.source) === null || _activity_order_source1 === void 0 ? void 0 : _activity_order_source1.icon) || "",
                                    alt: "".concat((_activity_order2 = activity.order) === null || _activity_order2 === void 0 ? void 0 : (_activity_order_source2 = _activity_order2.source) === null || _activity_order_source2 === void 0 ? void 0 : _activity_order_source2.name, " Source")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body2",
                                    color: "subtle",
                                    children: (0,hooks/* useTimeSince */.vS)(activity === null || activity === void 0 ? void 0 : activity.timestamp)
                                }),
                                activity.txHash && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                    href: "".concat(blockExplorerBaseUrl, "/tx/").concat(activity.txHash),
                                    color: "primary",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faExternalLink */.gJF,
                                        width: 12,
                                        height: 15
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "end",
                            css: {
                                gap: "$3"
                            },
                            children: [
                                activity.fromAddress && activity.fromAddress !== constants_address/* zeroAddress */.D ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    style: {
                                        display: "flex"
                                    },
                                    href: "/portfolio/".concat(activity.fromAddress),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        css: {
                                            color: "$primary11",
                                            "&:hover": {
                                                color: "$primary10"
                                            }
                                        },
                                        children: fromDisplayName
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "-"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body2",
                                    color: "subtle",
                                    children: "to"
                                }),
                                activity.toAddress && activity.toAddress !== constants_address/* zeroAddress */.D ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    style: {
                                        display: "flex"
                                    },
                                    href: "/portfolio/".concat(activity.toAddress),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        css: {
                                            color: "$primary11",
                                            "&:hover": {
                                                color: "$primary10"
                                            }
                                        },
                                        children: toDisplayName
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "-"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    }, activity.txHash);
};

// EXTERNAL MODULE: ./utils/numbers.ts + 1 modules
var numbers = __webpack_require__(23701);
;// CONCATENATED MODULE: ./components/token/AttributeCard.tsx





/* harmony default export */ var AttributeCard = ((param)=>{
    let { attribute , collectionTokenCount , collectionId  } = param;
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const attributeTokenCount = (attribute === null || attribute === void 0 ? void 0 : attribute.tokenCount) || 0;
    const totalTokens = collectionTokenCount ? Number(collectionTokenCount) : 0;
    const attributeRarity = (0,numbers/* formatNumber */.uf)(attributeTokenCount / totalTokens * 100, 1);
    const attributeHref = "/".concat(routePrefix, "/collection/").concat(collectionId, "?attributes[").concat(attribute.key, "]=").concat(attribute.value);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: attributeHref,
        style: {
            minWidth: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            css: {
                background: "$gray2",
                mr: "auto",
                px: "$4",
                py: "$3",
                borderRadius: 8,
                gap: "$1",
                width: "100%",
                height: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle3",
                    color: "subtle",
                    ellipsify: true,
                    children: attribute.key
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    css: {
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "subtitle2",
                            ellipsify: true,
                            children: attribute.value
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                            amount: attribute.floorAskPrice,
                            logoHeight: 16,
                            textStyle: "subtitle2",
                            maximumFractionDigits: 2
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    justify: "between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                            style: "body3",
                            css: {
                                color: "$gray11"
                            },
                            children: [
                                (0,numbers/* formatNumber */.uf)(attribute.tokenCount),
                                " (",
                                attributeRarity,
                                "%) have this"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "body3",
                            css: {
                                color: "$gray11"
                            },
                            children: "floor"
                        })
                    ]
                })
            ]
        })
    });
});

// EXTERNAL MODULE: ./components/primitives/Dialog.tsx
var Dialog = __webpack_require__(39114);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.module.js
var react_dialog_dist_index_module = __webpack_require__(51528);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 131 modules
var motion = __webpack_require__(12664);
;// CONCATENATED MODULE: ./components/token/FullscreenMedia.tsx








const FullscreenMedia = (param)=>{
    let { token  } = param;
    const mediaType = (0,dist_index_module/* extractMediaType */.uh)(token === null || token === void 0 ? void 0 : token.token);
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
        color: "gray3",
        corners: "circle",
        css: {
            position: "absolute",
            right: 12,
            top: 12
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: free_solid_svg_icons/* faExpand */.TL5,
            width: 16,
            height: 16
        })
    });
    if (mediaType === "png" || mediaType === "jpeg" || mediaType === "jpg" || mediaType === "gif" || mediaType === null || mediaType === undefined) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dialog_dist_index_module/* Root */.fC, {
        modal: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist_index_module/* DialogTrigger */.hg, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dialog_dist_index_module/* DialogPortal */.PK, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* AnimatedOverlay */.Q3, {
                        style: {
                            position: "fixed",
                            zIndex: 1000,
                            inset: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0, 0, 0, 0.6)",
                            backdropFilter: "20px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist_index_module/* DialogClose */.GG, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                color: "gray3",
                                corners: "circle",
                                css: {
                                    position: "absolute",
                                    right: 12,
                                    top: 12
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faCompress */.Qj4,
                                    width: 16,
                                    height: 16
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Content */.VY, {
                        css: {
                            zIndex: 2000,
                            top: "50%",
                            border: "none",
                            borderRadius: 0,
                            background: "none",
                            transform: "translate(-50%, -50%)"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            transition: {
                                type: "spring",
                                duration: 1
                            },
                            initial: {
                                opacity: 0,
                                top: "0%"
                            },
                            animate: {
                                opacity: 1,
                                top: "50%"
                            },
                            exit: {
                                opacity: 0,
                                top: "0%"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                direction: "column",
                                align: "center",
                                justify: "center",
                                css: {
                                    flexDirection: "column",
                                    height: "100%",
                                    width: "100%",
                                    maxWidth: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* TokenMedia */.Y1, {
                                    token: token === null || token === void 0 ? void 0 : token.token,
                                    style: {
                                        borderRadius: 0,
                                        width: "100vw",
                                        height: "auto",
                                        padding: "4px"
                                    }
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
    else {
        return null;
    }
};
/* harmony default export */ var token_FullscreenMedia = (FullscreenMedia);

// EXTERNAL MODULE: ./components/buttons/index.ts + 3 modules
var buttons = __webpack_require__(52158);
// EXTERNAL MODULE: ./components/buttons/AddToCart.tsx + 1 modules
var AddToCart = __webpack_require__(98745);
// EXTERNAL MODULE: ./components/buttons/CancelListing.tsx
var CancelListing = __webpack_require__(41456);
// EXTERNAL MODULE: ./node_modules/@rainbow-me/rainbowkit/dist/chunk-3B7JRKV5.js + 15 modules
var chunk_3B7JRKV5 = __webpack_require__(87671);
// EXTERNAL MODULE: ./context/ToastContextProvider.tsx + 4 modules
var ToastContextProvider = __webpack_require__(98045);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(69077);
;// CONCATENATED MODULE: ./components/buttons/EditListing.tsx








const EditListing = (param)=>{
    let { listingId , tokenId , collectionId , disabled , openState , buttonCss , buttonProps , buttonChildren , mutate  } = param;
    const { isDisconnected  } = (0,dist/* useAccount */.mA)();
    const { openConnectModal  } = (0,chunk_3B7JRKV5/* useConnectModal */.We)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { switchNetworkAsync  } = (0,dist/* useSwitchNetwork */.g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,dist/* useWalletClient */.py)();
    const { chain: activeChain  } = (0,dist/* useNetwork */.LN)();
    const isInTheWrongNetwork = Boolean(signer && marketplaceChain.id !== (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id));
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
        css: buttonCss,
        disabled: disabled,
        ...buttonProps,
        color: "gray3",
        children: buttonChildren
    });
    if (isDisconnected || isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    } else return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* EditListingModal */.oU, {
        trigger: trigger,
        openState: openState,
        listingId: listingId,
        tokenId: tokenId,
        collectionId: collectionId,
        onClose: (data, currentStep)=>{
            if (mutate && currentStep == dist_index_module/* EditListingStep.Complete */.qy.Complete) mutate();
        },
        onEditListingError: (error)=>{
            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) {
                addToast === null || addToast === void 0 ? void 0 : addToast({
                    title: "User canceled transaction",
                    description: "You have canceled the transaction."
                });
                return;
            }
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not edit listing",
                description: "The transaction was not completed."
            });
        }
    });
};
/* harmony default export */ var buttons_EditListing = (EditListing);

// EXTERNAL MODULE: ./context/ChainContextProvider.tsx
var ChainContextProvider = __webpack_require__(43810);
;// CONCATENATED MODULE: ./components/token/OnlyUserOrdersToggle.tsx


const OnlyUserOrdersToggle = (param)=>{
    let { checked , onCheckedChange  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        align: "center",
        justify: "between",
        css: {
            width: "100%",
            backgroundColor: "$gray2",
            borderRadius: 4,
            py: "$3",
            px: "$4",
            gap: "$3"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                style: "subtitle2",
                color: "subtle",
                children: "Only Mine"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Switch */.rs, {
                checked: checked,
                onCheckedChange: (checked)=>onCheckedChange(checked)
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/token/ListingsTable.tsx


















const ListingsTable = (param)=>{
    let { token , address , is1155 , isOwner  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    const [userOnly, setUserOnly] = (0,react.useState)(false);
    let listingsQuery = {
        maker: userOnly ? address : undefined,
        token: token,
        includeCriteriaMetadata: true,
        includeRawData: true,
        sortBy: "price"
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.community) {
        listingsQuery.community = chain.community;
    }
    const { data: listings , fetchNextPage , mutate , isValidating , isFetchingPage , isLoading  } = (0,dist_index_module/* useListings */.Jn)(listingsQuery, {
        revalidateFirstPage: true
    });
    const { data: userListings  } = (0,dist_index_module/* useListings */.Jn)({
        ...listingsQuery,
        maker: address
    });
    const userHasListings = userListings.length > 0;
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isValidating && !isFetchingPage && listings && listings.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faTag */.LEN,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No listings yet"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    gap: "$4"
                },
                children: [
                    address && userHasListings && is1155 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlyUserOrdersToggle, {
                        checked: userOnly,
                        onCheckedChange: (checked)=>setUserOnly(checked)
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            height: "100%",
                            maxHeight: isLoading ? "20px" : "450px",
                            overflowY: "auto",
                            width: "100%",
                            pb: "$2"
                        },
                        children: [
                            listings.map((listing, i)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingTableRow, {
                                    listing: listing,
                                    tokenString: token,
                                    address: address,
                                    is1155: is1155,
                                    isOwner: isOwner,
                                    mutate: mutate
                                }, "".concat(listing === null || listing === void 0 ? void 0 : listing.id, "-").concat(i));
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                ref: loadMoreRef,
                                css: {
                                    height: 20
                                }
                            })
                        ]
                    })
                ]
            }),
            isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$5"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            })
        ]
    });
};
const ListingTableRow = (param)=>{
    let { listing , tokenString , is1155 , isOwner , address , mutate  } = param;
    var _listing_source, _listing_source1, _listing_price, _listing_price_amount, _listing_price1, _listing_price_currency, _listing_price2, _listing_price_amount1, _listing_price3, _listing_price_amount2, _listing_criteria, _listing_criteria_data, _listing_criteria_data_token, _listing_criteria1, _listing_criteria_data1, _listing_criteria_data_collection, _listing_criteria2, _listing_criteria_data2, _listing_criteria_data_token1, _listing_criteria3, _listing_criteria_data3, _listing_criteria_data_collection1;
    const { displayName: fromDisplayName  } = (0,hooks/* useENSResolver */.Af)(listing.maker);
    const { reservoirBaseUrl  } = (0,hooks/* useMarketplaceChain */.gw)();
    const expiration = (0,hooks/* useTimeSince */.vS)(listing === null || listing === void 0 ? void 0 : listing.expiration);
    const expirationText = expiration ? "Expires ".concat(expiration) : null;
    const isUserListing = (address === null || address === void 0 ? void 0 : address.toLowerCase()) === listing.maker.toLowerCase();
    const isOracleOrder = listing === null || listing === void 0 ? void 0 : listing.isNativeOffChainCancellable;
    const contract = tokenString === null || tokenString === void 0 ? void 0 : tokenString.split(":")[0];
    const tokenId = tokenString === null || tokenString === void 0 ? void 0 : tokenString.split(":")[1];
    const listingSourceName = listing === null || listing === void 0 ? void 0 : (_listing_source = listing.source) === null || _listing_source === void 0 ? void 0 : _listing_source.name;
    const listingSourceDomain = listing === null || listing === void 0 ? void 0 : (_listing_source1 = listing.source) === null || _listing_source1 === void 0 ? void 0 : _listing_source1.domain;
    const listingSourceLogo = "".concat(reservoirBaseUrl, "/redirect/sources/").concat(listingSourceDomain || listingSourceName, "/logo/v2");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: "none",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            py: "$3"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "start",
                css: {
                    height: "100%",
                    gap: "$2"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            gap: "$1",
                            height: 36
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                amount: (_listing_price = listing.price) === null || _listing_price === void 0 ? void 0 : (_listing_price_amount = _listing_price.amount) === null || _listing_price_amount === void 0 ? void 0 : _listing_price_amount.decimal,
                                address: (_listing_price1 = listing.price) === null || _listing_price1 === void 0 ? void 0 : (_listing_price_currency = _listing_price1.currency) === null || _listing_price_currency === void 0 ? void 0 : _listing_price_currency.contract,
                                logoHeight: 16,
                                textStyle: "h6"
                            }),
                            ((_listing_price2 = listing.price) === null || _listing_price2 === void 0 ? void 0 : (_listing_price_amount1 = _listing_price2.amount) === null || _listing_price_amount1 === void 0 ? void 0 : _listing_price_amount1.usd) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body2",
                                css: {
                                    color: "$gray11"
                                },
                                ellipsify: true,
                                children: (0,numbers/* formatDollar */.el)((_listing_price3 = listing.price) === null || _listing_price3 === void 0 ? void 0 : (_listing_price_amount2 = _listing_price3.amount) === null || _listing_price_amount2 === void 0 ? void 0 : _listing_price_amount2.usd)
                            }) : null,
                            (listing === null || listing === void 0 ? void 0 : listing.quantityRemaining) && (listing === null || listing === void 0 ? void 0 : listing.quantityRemaining) > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                justify: "center",
                                align: "center",
                                css: {
                                    borderRadius: 4,
                                    px: "$2",
                                    py: "$1",
                                    ml: "$1",
                                    backgroundColor: "$gray2"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                    style: "subtitle2",
                                    color: "subtle",
                                    children: [
                                        "x",
                                        (0,numbers/* formatNumber */.uf)(listing.quantityRemaining, 0, true)
                                    ]
                                })
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            gap: "$1"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body2",
                                color: "subtle",
                                css: {
                                    lineHeight: "14.5px"
                                },
                                children: "from"
                            }),
                            listing.maker && listing.maker !== constants_address/* zeroAddress */.D ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/portfolio/".concat(listing.maker),
                                style: {
                                    lineHeight: "14.5px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle2",
                                    css: {
                                        color: "$primary11",
                                        "&:hover": {
                                            color: "$primary10"
                                        }
                                    },
                                    children: fromDisplayName
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "-"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                width: 16,
                                height: 16,
                                src: listingSourceLogo
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "end",
                css: {
                    gap: "$2"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            !isOwner && !is1155 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* BuyNow */.Wg, {
                                tokenId: ((_listing_criteria = listing.criteria) === null || _listing_criteria === void 0 ? void 0 : (_listing_criteria_data = _listing_criteria.data) === null || _listing_criteria_data === void 0 ? void 0 : (_listing_criteria_data_token = _listing_criteria_data.token) === null || _listing_criteria_data_token === void 0 ? void 0 : _listing_criteria_data_token.tokenId) || tokenId,
                                collectionId: ((_listing_criteria1 = listing.criteria) === null || _listing_criteria1 === void 0 ? void 0 : (_listing_criteria_data1 = _listing_criteria1.data) === null || _listing_criteria_data1 === void 0 ? void 0 : (_listing_criteria_data_collection = _listing_criteria_data1.collection) === null || _listing_criteria_data_collection === void 0 ? void 0 : _listing_criteria_data_collection.id) || contract,
                                orderId: listing.id,
                                buttonChildren: "Buy",
                                buttonCss: {
                                    fontSize: 14,
                                    px: "$4",
                                    py: "$2",
                                    minHeight: 36
                                },
                                mutate: mutate
                            }) : null,
                            !isUserListing && is1155 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                                orderId: listing.id,
                                buttonCss: {
                                    width: 42,
                                    height: 36,
                                    minHeight: 36,
                                    p: 0,
                                    justifyContent: "center"
                                },
                                buttonProps: {
                                    corners: "rounded"
                                }
                            }) : null,
                            isOwner && isUserListing ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_EditListing, {
                                        listingId: listing.id,
                                        tokenId: ((_listing_criteria2 = listing.criteria) === null || _listing_criteria2 === void 0 ? void 0 : (_listing_criteria_data2 = _listing_criteria2.data) === null || _listing_criteria_data2 === void 0 ? void 0 : (_listing_criteria_data_token1 = _listing_criteria_data2.token) === null || _listing_criteria_data_token1 === void 0 ? void 0 : _listing_criteria_data_token1.tokenId) || tokenId,
                                        collectionId: ((_listing_criteria3 = listing.criteria) === null || _listing_criteria3 === void 0 ? void 0 : (_listing_criteria_data3 = _listing_criteria3.data) === null || _listing_criteria_data3 === void 0 ? void 0 : (_listing_criteria_data_collection1 = _listing_criteria_data3.collection) === null || _listing_criteria_data_collection1 === void 0 ? void 0 : _listing_criteria_data_collection1.id) || contract,
                                        buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle2",
                                            children: "Edit"
                                        }),
                                        buttonCss: {
                                            fontSize: 14,
                                            px: "$4",
                                            py: "$2",
                                            minHeight: 36,
                                            minWidth: 80,
                                            justifyContent: "center"
                                        },
                                        mutate: mutate
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                                        listingId: listing === null || listing === void 0 ? void 0 : listing.id,
                                        mutate: mutate,
                                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                            children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "body3",
                                                    as: "p",
                                                    children: "Cancelling this order requires gas."
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                                                    css: {
                                                        color: "$red11",
                                                        justifyContent: "center",
                                                        fontSize: 14,
                                                        fontWeight: 500,
                                                        px: "$4",
                                                        py: "$2",
                                                        minHeight: 36
                                                    },
                                                    color: "gray3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            color: "#697177",
                                                            icon: free_solid_svg_icons/* faGasPump */.q16,
                                                            width: "16",
                                                            height: "16"
                                                        }),
                                                        "Cancel"
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                                css: {
                                                    color: "$red11",
                                                    justifyContent: "center",
                                                    fontSize: 14,
                                                    fontWeight: 500,
                                                    px: "$4",
                                                    py: "$2",
                                                    minHeight: 36
                                                },
                                                color: "gray3",
                                                children: "Cancel"
                                            })
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "body2",
                        color: "subtle",
                        children: expirationText
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/buttons/CancelBid.tsx
var CancelBid = __webpack_require__(61818);
;// CONCATENATED MODULE: ./components/buttons/EditBid.tsx








const EditBid = (param)=>{
    let { bidId , tokenId , collectionId , disabled , openState , buttonCss , buttonProps , buttonChildren , mutate  } = param;
    const { isDisconnected  } = (0,dist/* useAccount */.mA)();
    const { openConnectModal  } = (0,chunk_3B7JRKV5/* useConnectModal */.We)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { switchNetworkAsync  } = (0,dist/* useSwitchNetwork */.g0)({
        chainId: marketplaceChain.id
    });
    const { data: signer  } = (0,dist/* useWalletClient */.py)();
    const { chain: activeChain  } = (0,dist/* useNetwork */.LN)();
    const isInTheWrongNetwork = Boolean(signer && marketplaceChain.id !== (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id));
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
        css: buttonCss,
        disabled: disabled,
        ...buttonProps,
        color: "gray3",
        children: buttonChildren
    });
    if (isDisconnected || isInTheWrongNetwork) {
        return /*#__PURE__*/ (0,react.cloneElement)(trigger, {
            onClick: async ()=>{
                if (switchNetworkAsync && activeChain) {
                    const chain = await switchNetworkAsync(marketplaceChain.id);
                    if (chain.id !== marketplaceChain.id) {
                        return false;
                    }
                }
                if (!signer) {
                    openConnectModal === null || openConnectModal === void 0 ? void 0 : openConnectModal();
                }
            }
        });
    } else return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* EditBidModal */.O7, {
        trigger: trigger,
        openState: openState,
        bidId: bidId,
        tokenId: tokenId,
        collectionId: collectionId,
        onClose: (data, currentStep)=>{
            if (mutate && currentStep == dist_index_module/* EditBidStep.Complete */.bA.Complete) mutate();
        },
        onEditBidError: (error)=>{
            if ((error === null || error === void 0 ? void 0 : error.code) === 4001) {
                addToast === null || addToast === void 0 ? void 0 : addToast({
                    title: "User canceled transaction",
                    description: "You have canceled the transaction."
                });
                return;
            }
            addToast === null || addToast === void 0 ? void 0 : addToast({
                title: "Could not edit offer",
                description: "The transaction was not completed."
            });
        }
    });
};
/* harmony default export */ var buttons_EditBid = (EditBid);

;// CONCATENATED MODULE: ./components/token/OffersTable.tsx

















const OffersTable = (param)=>{
    let { token , address , is1155 , isOwner  } = param;
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    const [userOnly, setUserOnly] = (0,react.useState)(false);
    let bidsQuery = {
        maker: userOnly ? address : undefined,
        token: token,
        includeCriteriaMetadata: true,
        includeRawData: true,
        sortBy: "price"
    };
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    if (chain.community) {
        bidsQuery.community = chain.community;
    }
    const { data: offers , fetchNextPage , mutate , isValidating , isFetchingPage , isLoading  } = (0,dist_index_module/* useBids */.Lk)(bidsQuery, {
        revalidateFirstPage: true
    });
    const { data: userOffers  } = (0,dist_index_module/* useBids */.Lk)({
        ...bidsQuery,
        maker: address
    });
    const userHasOffers = userOffers.length > 0;
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !isValidating && !isFetchingPage && offers && offers.length === 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    py: "$6",
                    gap: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faHand */.ioV,
                            size: "2xl"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        css: {
                            color: "$gray11"
                        },
                        children: "No offers made yet"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                css: {
                    gap: "$4"
                },
                children: [
                    address && userHasOffers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(OnlyUserOrdersToggle, {
                        checked: userOnly,
                        onCheckedChange: (checked)=>setUserOnly(checked)
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            height: "100%",
                            maxHeight: isLoading ? "20px" : "450px",
                            overflowY: "auto",
                            width: "100%",
                            pb: "$2"
                        },
                        children: [
                            offers.map((offer, i)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferTableRow, {
                                    offer: offer,
                                    tokenString: token,
                                    address: address,
                                    is1155: is1155,
                                    isOwner: isOwner,
                                    mutate: mutate
                                }, "".concat(offer === null || offer === void 0 ? void 0 : offer.id, "-").concat(i));
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                ref: loadMoreRef,
                                css: {
                                    height: 20
                                }
                            })
                        ]
                    })
                ]
            }),
            isValidating && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                align: "center",
                justify: "center",
                css: {
                    py: "$5"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {})
            })
        ]
    });
};
const OfferTableRow = (param)=>{
    let { offer , tokenString , is1155 , isOwner , address , mutate  } = param;
    var _offer_source, _offer_source1, _offer_price, _offer_price_amount, _offer_price1, _offer_price_currency, _offer_price2, _offer_price_amount1, _offer_price3, _offer_price_amount2, _offer_criteria, _offer_criteria_data, _offer_criteria_data_collection, _offer_criteria1, _offer_criteria_data1, _offer_criteria_data_token, _offer_criteria2, _offer_criteria_data2, _offer_criteria_data_token1, _offer_criteria3, _offer_criteria_data3, _offer_criteria_data_collection1;
    const { displayName: fromDisplayName  } = (0,hooks/* useENSResolver */.Af)(offer.maker);
    const { reservoirBaseUrl  } = (0,hooks/* useMarketplaceChain */.gw)();
    const expiration = (0,hooks/* useTimeSince */.vS)(offer === null || offer === void 0 ? void 0 : offer.expiration);
    const expirationText = expiration ? "Expires ".concat(expiration) : null;
    const isUserOffer = (address === null || address === void 0 ? void 0 : address.toLowerCase()) === offer.maker.toLowerCase();
    const isOracleOrder = offer === null || offer === void 0 ? void 0 : offer.isNativeOffChainCancellable;
    const contract = tokenString === null || tokenString === void 0 ? void 0 : tokenString.split(":")[0];
    const tokenId = tokenString === null || tokenString === void 0 ? void 0 : tokenString.split(":")[1];
    const offerSourceName = offer === null || offer === void 0 ? void 0 : (_offer_source = offer.source) === null || _offer_source === void 0 ? void 0 : _offer_source.name;
    const offerSourceDomain = offer === null || offer === void 0 ? void 0 : (_offer_source1 = offer.source) === null || _offer_source1 === void 0 ? void 0 : _offer_source1.domain;
    const offerSourceLogo = "".concat(reservoirBaseUrl, "/redirect/sources/").concat(offerSourceDomain || offerSourceName, "/logo/v2");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* TableRow */.SC, {
        css: {
            gridTemplateColumns: "none",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            py: "$3"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "start",
                css: {
                    height: "100%",
                    gap: "$1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            gap: "$1",
                            height: 36
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                amount: (_offer_price = offer.price) === null || _offer_price === void 0 ? void 0 : (_offer_price_amount = _offer_price.amount) === null || _offer_price_amount === void 0 ? void 0 : _offer_price_amount.decimal,
                                address: (_offer_price1 = offer.price) === null || _offer_price1 === void 0 ? void 0 : (_offer_price_currency = _offer_price1.currency) === null || _offer_price_currency === void 0 ? void 0 : _offer_price_currency.contract,
                                logoHeight: 16,
                                textStyle: "h6"
                            }),
                            ((_offer_price2 = offer.price) === null || _offer_price2 === void 0 ? void 0 : (_offer_price_amount1 = _offer_price2.amount) === null || _offer_price_amount1 === void 0 ? void 0 : _offer_price_amount1.usd) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body2",
                                css: {
                                    color: "$gray11"
                                },
                                ellipsify: true,
                                children: (0,numbers/* formatDollar */.el)((_offer_price3 = offer.price) === null || _offer_price3 === void 0 ? void 0 : (_offer_price_amount2 = _offer_price3.amount) === null || _offer_price_amount2 === void 0 ? void 0 : _offer_price_amount2.usd)
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            gap: "$1"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body2",
                                color: "subtle",
                                css: {
                                    lineHeight: "14.5px"
                                },
                                children: "from"
                            }),
                            offer.maker && offer.maker !== constants_address/* zeroAddress */.D ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/portfolio/".concat(offer.maker),
                                style: {
                                    lineHeight: "14.5px"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle2",
                                    css: {
                                        color: "$primary11",
                                        "&:hover": {
                                            color: "$primary10"
                                        }
                                    },
                                    children: fromDisplayName
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "-"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                width: 16,
                                height: 16,
                                src: offerSourceLogo
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "end",
                css: {
                    gap: "$2"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            gap: "$2"
                        },
                        children: [
                            isOwner && !isUserOffer ? /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* AcceptBid */.ZS, {
                                bidId: offer.id,
                                collectionId: ((_offer_criteria = offer.criteria) === null || _offer_criteria === void 0 ? void 0 : (_offer_criteria_data = _offer_criteria.data) === null || _offer_criteria_data === void 0 ? void 0 : (_offer_criteria_data_collection = _offer_criteria_data.collection) === null || _offer_criteria_data_collection === void 0 ? void 0 : _offer_criteria_data_collection.id) || contract,
                                tokenId: ((_offer_criteria1 = offer.criteria) === null || _offer_criteria1 === void 0 ? void 0 : (_offer_criteria_data1 = _offer_criteria1.data) === null || _offer_criteria_data1 === void 0 ? void 0 : (_offer_criteria_data_token = _offer_criteria_data1.token) === null || _offer_criteria_data_token === void 0 ? void 0 : _offer_criteria_data_token.tokenId) || tokenId,
                                buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle2",
                                    css: {
                                        color: "white"
                                    },
                                    children: "Accept"
                                }),
                                buttonProps: {
                                    color: "primary"
                                },
                                buttonCss: {
                                    fontSize: 14,
                                    px: "$4",
                                    py: "$2",
                                    minHeight: 36
                                }
                            }) : null,
                            !isOwner && isUserOffer || isOwner && is1155 && isUserOffer ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_EditBid, {
                                        bidId: offer.id,
                                        tokenId: ((_offer_criteria2 = offer.criteria) === null || _offer_criteria2 === void 0 ? void 0 : (_offer_criteria_data2 = _offer_criteria2.data) === null || _offer_criteria_data2 === void 0 ? void 0 : (_offer_criteria_data_token1 = _offer_criteria_data2.token) === null || _offer_criteria_data_token1 === void 0 ? void 0 : _offer_criteria_data_token1.tokenId) || tokenId,
                                        collectionId: ((_offer_criteria3 = offer.criteria) === null || _offer_criteria3 === void 0 ? void 0 : (_offer_criteria_data3 = _offer_criteria3.data) === null || _offer_criteria_data3 === void 0 ? void 0 : (_offer_criteria_data_collection1 = _offer_criteria_data3.collection) === null || _offer_criteria_data_collection1 === void 0 ? void 0 : _offer_criteria_data_collection1.id) || contract,
                                        buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle2",
                                            children: "Edit"
                                        }),
                                        buttonCss: {
                                            fontSize: 14,
                                            px: "$4",
                                            py: "$2",
                                            minHeight: 36,
                                            minWidth: 80,
                                            justifyContent: "center"
                                        },
                                        mutate: mutate
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelBid/* default */.Z, {
                                        bidId: offer === null || offer === void 0 ? void 0 : offer.id,
                                        mutate: mutate,
                                        trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                            children: !isOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                                content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "body3",
                                                    as: "p",
                                                    children: "Cancelling this order requires gas."
                                                }),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                                                    css: {
                                                        color: "$red11",
                                                        justifyContent: "center",
                                                        fontSize: 14,
                                                        fontWeight: 500,
                                                        px: "$4",
                                                        py: "$2",
                                                        minHeight: 36
                                                    },
                                                    color: "gray3",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            color: "#697177",
                                                            icon: free_solid_svg_icons/* faGasPump */.q16,
                                                            width: "16",
                                                            height: "16"
                                                        }),
                                                        "Cancel"
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                                css: {
                                                    color: "$red11",
                                                    justifyContent: "center",
                                                    fontSize: 14,
                                                    fontWeight: 500,
                                                    px: "$4",
                                                    py: "$2",
                                                    minHeight: 36
                                                },
                                                color: "gray3",
                                                children: "Cancel"
                                            })
                                        })
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "body2",
                        color: "subtle",
                        children: expirationText
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/token/PriceData.tsx




const PriceData = (param)=>{
    let { token  } = param;
    var _token_market, _token_market_floorAsk, _token_market_floorAsk_source, _token_market1, _token_market_floorAsk1, _token_market_floorAsk_source1, _token_market2, _token_market_topBid, _token_market_topBid_source, _token_market3, _token_market_topBid1, _token_market_topBid_source1, _token_token, _token_token1, _token_token2, _token_token3, _token_market4, _token_market_floorAsk2, _token_market_floorAsk_price, _token_market_floorAsk_price_amount, _token_market5, _token_market_floorAsk3, _token_market_floorAsk_price1, _token_market_floorAsk_price_currency, _token_market6, _token_market_floorAsk4, _token_market_floorAsk_price2, _token_market_floorAsk_price_currency1, _token_market7, _token_market_floorAsk5, _token_market_floorAsk_price3, _token_market_floorAsk_price_amount1, _token_market8, _token_market_floorAsk6, _token_market_floorAsk_price4, _token_market_floorAsk_price_amount2, _token_market9, _token_market_topBid2, _token_market_topBid_price, _token_market_topBid_price_amount, _token_market10, _token_market_topBid3, _token_market_topBid_price1, _token_market_topBid_price_currency, _token_market11, _token_market_topBid4, _token_market_topBid_price2, _token_market_topBid_price_currency1, _token_market12, _token_market_topBid5, _token_market_topBid_price3, _token_market_topBid_price_amount1, _token_market13, _token_market_topBid6, _token_market_topBid_price4, _token_market_topBid_price_amount2;
    const { reservoirBaseUrl  } = (0,hooks/* useMarketplaceChain */.gw)();
    const listSourceName = token === null || token === void 0 ? void 0 : (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : (_token_market_floorAsk_source = _token_market_floorAsk.source) === null || _token_market_floorAsk_source === void 0 ? void 0 : _token_market_floorAsk_source.name;
    const listSourceDomain = token === null || token === void 0 ? void 0 : (_token_market1 = token.market) === null || _token_market1 === void 0 ? void 0 : (_token_market_floorAsk1 = _token_market1.floorAsk) === null || _token_market_floorAsk1 === void 0 ? void 0 : (_token_market_floorAsk_source1 = _token_market_floorAsk1.source) === null || _token_market_floorAsk_source1 === void 0 ? void 0 : _token_market_floorAsk_source1.domain;
    const offerSourceName = token === null || token === void 0 ? void 0 : (_token_market2 = token.market) === null || _token_market2 === void 0 ? void 0 : (_token_market_topBid = _token_market2.topBid) === null || _token_market_topBid === void 0 ? void 0 : (_token_market_topBid_source = _token_market_topBid.source) === null || _token_market_topBid_source === void 0 ? void 0 : _token_market_topBid_source.name;
    const offerSourceDomain = token === null || token === void 0 ? void 0 : (_token_market3 = token.market) === null || _token_market3 === void 0 ? void 0 : (_token_market_topBid1 = _token_market3.topBid) === null || _token_market_topBid1 === void 0 ? void 0 : (_token_market_topBid_source1 = _token_market_topBid1.source) === null || _token_market_topBid_source1 === void 0 ? void 0 : _token_market_topBid_source1.domain;
    const listSourceLogo = "".concat(reservoirBaseUrl, "/redirect/sources/").concat(listSourceDomain || listSourceName, "/logo/v2");
    const offerSourceLogo = "".concat(reservoirBaseUrl, "/redirect/sources/").concat(offerSourceDomain || offerSourceName, "/logo/v2");
    const listSourceRedirect = "".concat(reservoirBaseUrl, "/redirect/sources/").concat(listSourceDomain || listSourceName, "/tokens/").concat(token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.tokenId, "/link/v2");
    const offerSourceRedirect = "".concat(reservoirBaseUrl, "/redirect/sources/").concat(offerSourceDomain || offerSourceName, "/tokens/").concat(token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.tokenId, "/link/v2");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        css: {
            gap: "$6",
            pt: "$4",
            pb: "$5"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "start",
                css: {
                    gap: "$1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "subtitle2",
                        children: "Price"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            flexDirection: "column",
                            "@bp400": {
                                flexDirection: "row",
                                gap: "$2"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                amount: token === null || token === void 0 ? void 0 : (_token_market4 = token.market) === null || _token_market4 === void 0 ? void 0 : (_token_market_floorAsk2 = _token_market4.floorAsk) === null || _token_market_floorAsk2 === void 0 ? void 0 : (_token_market_floorAsk_price = _token_market_floorAsk2.price) === null || _token_market_floorAsk_price === void 0 ? void 0 : (_token_market_floorAsk_price_amount = _token_market_floorAsk_price.amount) === null || _token_market_floorAsk_price_amount === void 0 ? void 0 : _token_market_floorAsk_price_amount.decimal,
                                address: token === null || token === void 0 ? void 0 : (_token_market5 = token.market) === null || _token_market5 === void 0 ? void 0 : (_token_market_floorAsk3 = _token_market5.floorAsk) === null || _token_market_floorAsk3 === void 0 ? void 0 : (_token_market_floorAsk_price1 = _token_market_floorAsk3.price) === null || _token_market_floorAsk_price1 === void 0 ? void 0 : (_token_market_floorAsk_price_currency = _token_market_floorAsk_price1.currency) === null || _token_market_floorAsk_price_currency === void 0 ? void 0 : _token_market_floorAsk_price_currency.contract,
                                decimals: token === null || token === void 0 ? void 0 : (_token_market6 = token.market) === null || _token_market6 === void 0 ? void 0 : (_token_market_floorAsk4 = _token_market6.floorAsk) === null || _token_market_floorAsk4 === void 0 ? void 0 : (_token_market_floorAsk_price2 = _token_market_floorAsk4.price) === null || _token_market_floorAsk_price2 === void 0 ? void 0 : (_token_market_floorAsk_price_currency1 = _token_market_floorAsk_price2.currency) === null || _token_market_floorAsk_price_currency1 === void 0 ? void 0 : _token_market_floorAsk_price_currency1.decimals,
                                textStyle: "h4",
                                logoHeight: 20,
                                maximumFractionDigits: 4
                            }),
                            (token === null || token === void 0 ? void 0 : (_token_market7 = token.market) === null || _token_market7 === void 0 ? void 0 : (_token_market_floorAsk5 = _token_market7.floorAsk) === null || _token_market_floorAsk5 === void 0 ? void 0 : (_token_market_floorAsk_price3 = _token_market_floorAsk5.price) === null || _token_market_floorAsk_price3 === void 0 ? void 0 : (_token_market_floorAsk_price_amount1 = _token_market_floorAsk_price3.amount) === null || _token_market_floorAsk_price_amount1 === void 0 ? void 0 : _token_market_floorAsk_price_amount1.usd) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body3",
                                css: {
                                    color: "$gray11"
                                },
                                ellipsify: true,
                                children: (0,numbers/* formatDollar */.el)(token === null || token === void 0 ? void 0 : (_token_market8 = token.market) === null || _token_market8 === void 0 ? void 0 : (_token_market_floorAsk6 = _token_market8.floorAsk) === null || _token_market_floorAsk6 === void 0 ? void 0 : (_token_market_floorAsk_price4 = _token_market_floorAsk6.price) === null || _token_market_floorAsk_price4 === void 0 ? void 0 : (_token_market_floorAsk_price_amount2 = _token_market_floorAsk_price4.amount) === null || _token_market_floorAsk_price_amount2 === void 0 ? void 0 : _token_market_floorAsk_price_amount2.usd)
                            }) : null
                        ]
                    }),
                    listSourceName && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: listSourceRedirect,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                borderRadius: 4,
                                gap: "$1",
                                width: "max-content"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    width: "20px",
                                    height: "20px",
                                    src: listSourceLogo
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body3",
                                    css: {
                                        color: "$gray11"
                                    },
                                    children: listSourceName
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "start",
                css: {
                    gap: "$1"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "subtitle2",
                        children: "Top Offer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        align: "center",
                        css: {
                            flexDirection: "column",
                            "@bp400": {
                                flexDirection: "row",
                                gap: "$2"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                amount: token === null || token === void 0 ? void 0 : (_token_market9 = token.market) === null || _token_market9 === void 0 ? void 0 : (_token_market_topBid2 = _token_market9.topBid) === null || _token_market_topBid2 === void 0 ? void 0 : (_token_market_topBid_price = _token_market_topBid2.price) === null || _token_market_topBid_price === void 0 ? void 0 : (_token_market_topBid_price_amount = _token_market_topBid_price.amount) === null || _token_market_topBid_price_amount === void 0 ? void 0 : _token_market_topBid_price_amount.decimal,
                                address: token === null || token === void 0 ? void 0 : (_token_market10 = token.market) === null || _token_market10 === void 0 ? void 0 : (_token_market_topBid3 = _token_market10.topBid) === null || _token_market_topBid3 === void 0 ? void 0 : (_token_market_topBid_price1 = _token_market_topBid3.price) === null || _token_market_topBid_price1 === void 0 ? void 0 : (_token_market_topBid_price_currency = _token_market_topBid_price1.currency) === null || _token_market_topBid_price_currency === void 0 ? void 0 : _token_market_topBid_price_currency.contract,
                                decimals: token === null || token === void 0 ? void 0 : (_token_market11 = token.market) === null || _token_market11 === void 0 ? void 0 : (_token_market_topBid4 = _token_market11.topBid) === null || _token_market_topBid4 === void 0 ? void 0 : (_token_market_topBid_price2 = _token_market_topBid4.price) === null || _token_market_topBid_price2 === void 0 ? void 0 : (_token_market_topBid_price_currency1 = _token_market_topBid_price2.currency) === null || _token_market_topBid_price_currency1 === void 0 ? void 0 : _token_market_topBid_price_currency1.decimals,
                                textStyle: "h4",
                                logoHeight: 20,
                                maximumFractionDigits: 4
                            }),
                            (token === null || token === void 0 ? void 0 : (_token_market12 = token.market) === null || _token_market12 === void 0 ? void 0 : (_token_market_topBid5 = _token_market12.topBid) === null || _token_market_topBid5 === void 0 ? void 0 : (_token_market_topBid_price3 = _token_market_topBid5.price) === null || _token_market_topBid_price3 === void 0 ? void 0 : (_token_market_topBid_price_amount1 = _token_market_topBid_price3.amount) === null || _token_market_topBid_price_amount1 === void 0 ? void 0 : _token_market_topBid_price_amount1.usd) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                style: "body3",
                                css: {
                                    color: "$gray11"
                                },
                                ellipsify: true,
                                children: (0,numbers/* formatDollar */.el)(token === null || token === void 0 ? void 0 : (_token_market13 = token.market) === null || _token_market13 === void 0 ? void 0 : (_token_market_topBid6 = _token_market13.topBid) === null || _token_market_topBid6 === void 0 ? void 0 : (_token_market_topBid_price4 = _token_market_topBid6.price) === null || _token_market_topBid_price4 === void 0 ? void 0 : (_token_market_topBid_price_amount2 = _token_market_topBid_price4.amount) === null || _token_market_topBid_price_amount2 === void 0 ? void 0 : _token_market_topBid_price_amount2.usd)
                            }) : null
                        ]
                    }),
                    offerSourceName && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: offerSourceRedirect,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                borderRadius: 4,
                                gap: "$1",
                                width: "max-content"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    width: "20px",
                                    height: "20px",
                                    src: offerSourceLogo
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "body3",
                                    css: {
                                        color: "$gray11"
                                    },
                                    children: offerSourceName
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/token/RarityRank.tsx



/* harmony default export */ var RarityRank = ((param)=>{
    let { token , collection , collectionAttributes  } = param;
    var _token_token, _token_token1;
    const rarityRank = token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.rarityRank;
    const tokenCount = collection === null || collection === void 0 ? void 0 : collection.tokenCount;
    const rankPercentile = Math.floor(rarityRank / parseInt(tokenCount) * 100);
    const topPercentile = (percentile)=>{
        if (percentile <= 1) {
            return 1;
        } else if (percentile <= 5) {
            return 5;
        } else if (percentile <= 10) {
            return 10;
        } else if (percentile <= 15) {
            return 15;
        } else if (percentile <= 20) {
            return 20;
        } else if (percentile <= 25) {
            return 25;
        } else if (percentile <= 30) {
            return 30;
        } else if (percentile <= 40) {
            return 40;
        } else if (percentile <= 50) {
            return 50;
        } else return;
    };
    let topPercentileText = rankPercentile <= 50 && "Top ".concat(topPercentile(rankPercentile), "%");
    const rarityEnabledCollection = tokenCount && +tokenCount >= 2 && collectionAttributes && (collectionAttributes === null || collectionAttributes === void 0 ? void 0 : collectionAttributes.length) >= 2;
    if (rarityRank === undefined || rarityRank === null || (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.kind) === "erc1155" || !rarityEnabledCollection) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            align: "start",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "body3",
                    children: topPercentileText
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                    style: "body3",
                    ellipsify: true,
                    children: [
                        "Rarity rank:",
                        " ",
                        "".concat((0,numbers/* formatNumber */.uf)(rarityRank), "/\n            ").concat((0,numbers/* formatNumber */.uf)(tokenCount))
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "body3",
                    color: "subtle",
                    children: "By Poprank"
                })
            ]
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            align: "center",
            css: {
                background: "$gray2",
                mt: 24,
                mr: "auto",
                px: "$2",
                py: "$1",
                borderRadius: 4,
                gap: "$1",
                cursor: "pointer"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    style: {
                        width: 13,
                        height: 13
                    },
                    src: "/icons/rarity-icon.svg"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    css: {
                        color: "$gray11"
                    },
                    children: "Rank"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                    style: "subtitle2",
                    children: [
                        (0,numbers/* formatNumber */.uf)(rarityRank),
                        " "
                    ]
                })
            ]
        })
    });
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/token/TokenActions.tsx










const TokenActions = (param)=>{
    let { token , offer , listing , isOwner , mutate , account  } = param;
    var _token_token, _token_market, _token_market_topBid, _token_market1, _token_market_topBid1, _token_token1, _token_market2, _token_market_topBid2, _token_market_topBid_maker, _account_address, _token_market3, _token_market_floorAsk, _token_market4, _token_market_floorAsk1, _token_market_floorAsk_price, _token_market_floorAsk_price_amount, _token_market5, _token_market_floorAsk2, _token_market_floorAsk_price1, _token_token2, _token_token3, _token_token_collection, _token_token4, _token_token5, _token_token6, _token_token7, _token_token_collection1, _token_market6, _token_market_topBid3, _token_market7, _token_market_floorAsk3;
    const router = (0,next_router.useRouter)();
    const bidOpenState = (0,react.useState)(true);
    const queryBidId = router.query.bidId;
    const deeplinkToAcceptBid = router.query.acceptBid === "true";
    const is1155 = (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.kind) === "erc1155";
    const showAcceptOffer = !is1155 && (token === null || token === void 0 ? void 0 : (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_topBid = _token_market.topBid) === null || _token_market_topBid === void 0 ? void 0 : _token_market_topBid.id) !== null && (token === null || token === void 0 ? void 0 : (_token_market1 = token.market) === null || _token_market1 === void 0 ? void 0 : (_token_market_topBid1 = _token_market1.topBid) === null || _token_market_topBid1 === void 0 ? void 0 : _token_market_topBid1.id) !== undefined && isOwner && (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.owner) ? true : false;
    const isTopBidder = account.isConnected && (token === null || token === void 0 ? void 0 : (_token_market2 = token.market) === null || _token_market2 === void 0 ? void 0 : (_token_market_topBid2 = _token_market2.topBid) === null || _token_market_topBid2 === void 0 ? void 0 : (_token_market_topBid_maker = _token_market_topBid2.maker) === null || _token_market_topBid_maker === void 0 ? void 0 : _token_market_topBid_maker.toLowerCase()) === (account === null || account === void 0 ? void 0 : (_account_address = account.address) === null || _account_address === void 0 ? void 0 : _account_address.toLowerCase());
    const isListed = token ? (token === null || token === void 0 ? void 0 : (_token_market3 = token.market) === null || _token_market3 === void 0 ? void 0 : (_token_market_floorAsk = _token_market3.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : _token_market_floorAsk.id) !== null : false;
    const offerIsOracleOrder = offer === null || offer === void 0 ? void 0 : offer.isNativeOffChainCancellable;
    const listingIsOracleOrder = listing === null || listing === void 0 ? void 0 : listing.isNativeOffChainCancellable;
    const buttonCss = {
        width: "100%",
        height: 52,
        justifyContent: "center",
        minWidth: "max-content",
        "@sm": {
            maxWidth: 250
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Grid */.rj, {
        align: "center",
        css: {
            gap: "$4",
            gridTemplateColumns: "repeat(1,minmax(0,1fr))",
            width: "100%",
            "@sm": {
                gridTemplateColumns: "repeat(2,minmax(0,1fr))",
                maxWidth: 500
            }
        },
        children: [
            isOwner && !is1155 && /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* List */.aV, {
                token: token,
                mutate: mutate,
                buttonCss: buttonCss,
                buttonChildren: (token === null || token === void 0 ? void 0 : (_token_market4 = token.market) === null || _token_market4 === void 0 ? void 0 : (_token_market_floorAsk1 = _token_market4.floorAsk) === null || _token_market_floorAsk1 === void 0 ? void 0 : (_token_market_floorAsk_price = _token_market_floorAsk1.price) === null || _token_market_floorAsk_price === void 0 ? void 0 : (_token_market_floorAsk_price_amount = _token_market_floorAsk_price.amount) === null || _token_market_floorAsk_price_amount === void 0 ? void 0 : _token_market_floorAsk_price_amount.decimal) ? "Create New Listing" : "List for Sale"
            }),
            (!isOwner || is1155) && isListed && (token === null || token === void 0 ? void 0 : (_token_market5 = token.market) === null || _token_market5 === void 0 ? void 0 : (_token_market_floorAsk2 = _token_market5.floorAsk) === null || _token_market_floorAsk2 === void 0 ? void 0 : (_token_market_floorAsk_price1 = _token_market_floorAsk2.price) === null || _token_market_floorAsk_price1 === void 0 ? void 0 : _token_market_floorAsk_price1.amount) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    ...buttonCss,
                    borderRadius: 8,
                    overflow: "hidden",
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* BuyNow */.Wg, {
                        tokenId: (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.tokenId,
                        collectionId: (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : (_token_token_collection = _token_token3.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.id,
                        buttonCss: {
                            flex: 1,
                            justifyContent: "center"
                        },
                        buttonProps: {
                            corners: "square"
                        },
                        buttonChildren: "Buy Now",
                        mutate: mutate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart/* default */.Z, {
                        token: token,
                        buttonCss: {
                            width: 52,
                            p: 0,
                            justifyContent: "center"
                        },
                        buttonProps: {
                            corners: "square"
                        }
                    })
                ]
            }),
            showAcceptOffer && /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* AcceptBid */.ZS, {
                tokenId: (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.tokenId,
                bidId: queryBidId,
                collectionId: token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.contract,
                openState: isOwner && (queryBidId || deeplinkToAcceptBid) ? bidOpenState : undefined,
                mutate: mutate,
                buttonCss: buttonCss,
                buttonChildren: "Accept Offer"
            }),
            (!isOwner || is1155) && /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Bid */.QE, {
                tokenId: token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.tokenId,
                collectionId: token === null || token === void 0 ? void 0 : (_token_token7 = token.token) === null || _token_token7 === void 0 ? void 0 : (_token_token_collection1 = _token_token7.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.id,
                mutate: mutate,
                buttonCss: buttonCss
            }),
            isTopBidder && !is1155 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelBid/* default */.Z, {
                bidId: token === null || token === void 0 ? void 0 : (_token_market6 = token.market) === null || _token_market6 === void 0 ? void 0 : (_token_market_topBid3 = _token_market6.topBid) === null || _token_market_topBid3 === void 0 ? void 0 : _token_market_topBid3.id,
                mutate: mutate,
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    children: !offerIsOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "body3",
                            as: "p",
                            children: "Cancelling this order requires gas."
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                            css: {
                                color: "$red11",
                                width: "100%",
                                height: 52,
                                justifyContent: "center",
                                minWidth: "max-content",
                                "@sm": {
                                    maxWidth: 250
                                }
                            },
                            color: "gray3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    color: "#697177",
                                    icon: free_solid_svg_icons/* faGasPump */.q16,
                                    width: "16",
                                    height: "16"
                                }),
                                "Cancel Offer"
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        css: {
                            color: "$red11",
                            width: "100%",
                            height: 52,
                            justifyContent: "center",
                            minWidth: "max-content",
                            "@sm": {
                                maxWidth: 250
                            }
                        },
                        color: "gray3",
                        children: "Cancel Offer"
                    })
                })
            }),
            isOwner && isListed && !is1155 && /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelListing/* default */.Z, {
                listingId: token === null || token === void 0 ? void 0 : (_token_market7 = token.market) === null || _token_market7 === void 0 ? void 0 : (_token_market_floorAsk3 = _token_market7.floorAsk) === null || _token_market_floorAsk3 === void 0 ? void 0 : _token_market_floorAsk3.id,
                mutate: mutate,
                trigger: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    children: !listingIsOracleOrder ? /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "body3",
                            as: "p",
                            children: "Cancelling this order requires gas."
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                            css: {
                                color: "$red11",
                                minWidth: "150px"
                            },
                            color: "gray3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    color: "#697177",
                                    icon: free_solid_svg_icons/* faGasPump */.q16,
                                    width: "16",
                                    height: "16"
                                }),
                                "Cancel Listing"
                            ]
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        css: {
                            color: "$red11",
                            minWidth: "150px",
                            justifyContent: "center"
                        },
                        color: "gray3",
                        children: "Cancel Listing"
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(93024);
// EXTERNAL MODULE: ./stitches.config.ts + 1 modules
var stitches_config = __webpack_require__(50530);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var next_themes_dist_index_module = __webpack_require__(82010);
// EXTERNAL MODULE: ./utils/truncate.ts
var truncate = __webpack_require__(39525);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 126 modules
var react_markdown = __webpack_require__(73985);
// EXTERNAL MODULE: ./utils/titleCase.ts
var titleCase = __webpack_require__(68437);
// EXTERNAL MODULE: ./utils/optimizeImage.ts
var optimizeImage = __webpack_require__(77497);
;// CONCATENATED MODULE: ./components/token/TokenInfo.tsx















const TokenInfo = (param)=>{
    let { token , collection  } = param;
    var _token_token, _token_token_collection, _marketplaceChain_blockExplorers, _marketplaceChain_blockExplorers1, _token_token1, _token_token2, _token_token3, _token_token_collection1, _token_token4, _token_token5, _token_token6, _collection_royalties, _collection_royalties1;
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { theme  } = (0,next_themes_dist_index_module/* useTheme */.F)();
    const [isExpanded, setIsExpanded] = (0,react.useState)(false);
    const descriptionRef = (0,react.useRef)(null);
    const isMounted = (0,hooks/* useMounted */.s4)();
    const router = (0,next_router.useRouter)();
    let chain = (0,titleCase/* default */.Z)(router.query.chain);
    const CollectionAction = (0,stitches_config/* styled */.zo)(primitives/* Flex */.kC, {
        px: "$4",
        py: "$3",
        color: "$gray12",
        background: "$gray3",
        cursor: "pointer",
        transition: "background 0.25s ease-in",
        height: 40,
        alignItems: "center",
        "&:hover": {
            background: "$gray4"
        }
    });
    const collectionImage = (0,react.useMemo)(()=>{
        var _token_token, _token_token_collection;
        return (0,optimizeImage/* default */.Z)((token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_collection = _token_token.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.image) || (collection === null || collection === void 0 ? void 0 : collection.image), 250);
    }, [
        token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_collection = _token_token.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.image,
        collection === null || collection === void 0 ? void 0 : collection.image
    ]);
    const etherscanImage = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: isMounted && theme === "dark" ? "/icons/etherscan-logo-light-circle.svg" : "/icons/etherscan-logo-circle.svg",
        alt: "".concat(((_marketplaceChain_blockExplorers = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers === void 0 ? void 0 : _marketplaceChain_blockExplorers.default.name) || "Ethereum", " Icon"),
        height: 16,
        width: 16
    });
    const blockExplorerUrl = "".concat((marketplaceChain === null || marketplaceChain === void 0 ? void 0 : (_marketplaceChain_blockExplorers1 = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers1 === void 0 ? void 0 : _marketplaceChain_blockExplorers1.default.url) || "https://etherscan.io", "/token/").concat(token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.contract, "?a=").concat(token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.tokenId);
    const twitterLink = (collection === null || collection === void 0 ? void 0 : collection.twitterUsername) ? "https://twitter.com/".concat(collection === null || collection === void 0 ? void 0 : collection.twitterUsername) : null;
    const expandedCss = {
        maxWidth: "100%",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 2,
        textOverflow: "ellipsis",
        overflow: "hidden",
        verticalAlign: "top",
        "*": {
            display: "inline"
        }
    };
    let isLongDescription = false;
    if (descriptionRef.current) {
        isLongDescription = descriptionRef.current.offsetHeight > 50;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            direction: "column",
            css: {
                gap: "$3",
                maxWidth: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        gap: "$2",
                        flex: 1
                    },
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: collectionImage,
                            style: {
                                width: 36,
                                height: 36,
                                borderRadius: 4
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "h6",
                            ellipsify: true,
                            children: (token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : (_token_token_collection1 = _token_token3.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.name) || (collection === null || collection === void 0 ? void 0 : collection.name)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                            openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        fontSize: "16px",
                        fontFamily: 400,
                        overflow: "hidden",
                        a: {
                            textDecoration: "underline"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            direction: "column",
                            css: isExpanded ? undefined : expandedCss,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                ref: descriptionRef,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                    linkTarget: "_blank",
                                    children: collection === null || collection === void 0 ? void 0 : collection.description
                                })
                            })
                        }),
                        isLongDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                            color: "ghost",
                            size: "xs",
                            css: {
                                width: "max-content",
                                color: "$primary11",
                                fontWeight: 500,
                                height: 28,
                                minHeight: 28,
                                px: 0
                            },
                            onClick: ()=>{
                                setIsExpanded(!isExpanded);
                            },
                            children: isExpanded ? "read less" : "read more"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        borderRadius: 8,
                        overflow: "hidden",
                        gap: 1,
                        flexShrink: 0,
                        mb: "$3",
                        width: "max-content"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: blockExplorerUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                                children: etherscanImage
                            })
                        }),
                        twitterLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: twitterLink,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_brands_svg_icons/* faTwitter */.mdU,
                                    width: 16,
                                    height: 16
                                })
                            })
                        }),
                        (collection === null || collection === void 0 ? void 0 : collection.discordUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: collection.discordUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_brands_svg_icons/* faDiscord */.omb,
                                    width: 16,
                                    height: 16
                                })
                            })
                        }),
                        (collection === null || collection === void 0 ? void 0 : collection.externalUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: collection.externalUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faGlobe */.g4A,
                                    width: 16,
                                    height: 16
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        width: "100%",
                        gap: "$2"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "between",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        color: "$gray11",
                                        fontWeight: "normal"
                                    },
                                    children: "Contract Address"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                    href: blockExplorerUrl,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    color: "primary",
                                    weight: "medium",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: "$2"
                                        },
                                        children: [
                                            (0,truncate/* truncateAddress */.F)(token === null || token === void 0 ? void 0 : (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.contract),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faExternalLink */.gJF,
                                                width: 12,
                                                height: 15
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "between",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        color: "$gray11",
                                        fontWeight: "normal"
                                    },
                                    children: "Chain"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    children: chain
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "between",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        color: "$gray11",
                                        fontWeight: "normal",
                                        whiteSpace: "nowrap",
                                        mr: "$2"
                                    },
                                    children: "Token ID"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    ellipsify: true,
                                    css: {
                                        maxWidth: "100%"
                                    },
                                    children: token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.tokenId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "between",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        color: "$gray11",
                                        fontWeight: "normal"
                                    },
                                    children: "Token Standard"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        textTransform: "uppercase"
                                    },
                                    children: token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.kind
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            justify: "between",
                            css: {
                                width: "100%"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            css: {
                                                color: "$gray11",
                                                fontWeight: "normal"
                                            },
                                            children: "Creator Royalties"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "body3",
                                                as: "p",
                                                children: "A fee on every order that goes to the collection creator."
                                            }),
                                            style: {
                                                maxWidth: "210px"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                css: {
                                                    color: "$gray11"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faInfoCircle */.sqG,
                                                    width: 16,
                                                    height: 16
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    children: [
                                        (collection === null || collection === void 0 ? void 0 : (_collection_royalties = collection.royalties) === null || _collection_royalties === void 0 ? void 0 : _collection_royalties.bps) ? (collection === null || collection === void 0 ? void 0 : (_collection_royalties1 = collection.royalties) === null || _collection_royalties1 === void 0 ? void 0 : _collection_royalties1.bps) * 0.01 : 0,
                                        "%"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-jazzicon/dist/index.js
var react_jazzicon_dist = __webpack_require__(44111);
// EXTERNAL MODULE: ./node_modules/react-jazzicon/dist/Jazzicon.js
var Jazzicon = __webpack_require__(35342);
var Jazzicon_default = /*#__PURE__*/__webpack_require__.n(Jazzicon);
// EXTERNAL MODULE: ./utils/fetcher.ts
var fetcher = __webpack_require__(84205);
// EXTERNAL MODULE: ./utils/till.ts
var till = __webpack_require__(94830);
;// CONCATENATED MODULE: ./pages/[chain]/asset/[assetId].tsx



































const IndexPage = (param)=>{
    let { assetId , ssr  } = param;
    var _token_token, _token_token1, _token_token_collection, _token_token2, _token_token_collection1, _token_token3, _token_token4, _token_token_collection2, _token_token5, _token_token6, _token_token7, _token_token8, _token_token9, _token_token10, _token_token11, _token_token12, _token_token13, _token_token14, _token_token_collection3, _token_token15, _token_token16, _token_token17, _token_token_attributes, _token_token18, _token_token_collection4, _token_token19, _token_token_collection5, _token_token20, _token_token21, _token_token_attributes1, _token_token22, _token_token23, _token_token24;
    const assetIdPieces = assetId ? assetId.toString().split(":") : [];
    let collectionId = assetIdPieces[0];
    const id = assetIdPieces[1];
    const router = (0,next_router.useRouter)();
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const account = (0,dist/* useAccount */.mA)();
    const isMounted = (0,hooks/* useMounted */.s4)();
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 900
    }) && isMounted;
    const [tabValue, setTabValue] = (0,react.useState)("info");
    const [isRefreshing, setIsRefreshing] = (0,react.useState)(false);
    const [activityFiltersOpen, setActivityFiltersOpen] = (0,react.useState)(true);
    const [activityTypes, setActivityTypes] = (0,react.useState)([]);
    const [activityNames, setActivityNames] = (0,react.useState)([]);
    const { proxyApi  } = (0,hooks/* useMarketplaceChain */.gw)();
    const contract = collectionId ? collectionId === null || collectionId === void 0 ? void 0 : collectionId.split(":")[0] : undefined;
    const { data: tokens , mutate  } = (0,dist_index_module/* useDynamicTokens */.XN)({
        tokens: [
            "".concat(contract, ":").concat(id)
        ],
        includeAttributes: true,
        includeTopBid: true,
        includeQuantity: true
    }, {
        fallbackData: [
            ssr.tokens
        ]
    });
    const token = tokens && tokens[0] ? tokens[0] : undefined;
    const is1155 = (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.kind) === "erc1155";
    const { data: collections  } = (0,dist_index_module/* useCollections */.bX)({
        id: token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : (_token_token_collection = _token_token1.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.id
    }, {
        fallbackData: [
            ssr.collection
        ]
    });
    const collection = collections && collections[0] ? collections[0] : null;
    const { data: userTokens  } = (0,dist_index_module/* useUserTokens */.Vy)(is1155 ? account.address : undefined, {
        tokens: [
            "".concat(contract, ":").concat(id)
        ]
    });
    const { data: offers  } = (0,dist_index_module/* useBids */.Lk)({
        token: "".concat(token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : (_token_token_collection1 = _token_token2.collection) === null || _token_token_collection1 === void 0 ? void 0 : _token_token_collection1.id, ":").concat(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.tokenId),
        includeRawData: true,
        sortBy: "price",
        limit: 1
    });
    const { data: listings  } = (0,dist_index_module/* useListings */.Jn)({
        token: "".concat(token === null || token === void 0 ? void 0 : (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : (_token_token_collection2 = _token_token4.collection) === null || _token_token_collection2 === void 0 ? void 0 : _token_token_collection2.id, ":").concat(token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.tokenId),
        includeRawData: true,
        sortBy: "price",
        limit: 1
    });
    const offer = offers && offers[0] ? offers[0] : undefined;
    const listing = listings && listings[0] ? listings[0] : undefined;
    const attributesData = (0,dist_index_module/* useAttributes */.Ch)(collectionId);
    let countOwned = 0;
    if (is1155) {
        var _userTokens_, _userTokens__ownership;
        countOwned = Number((userTokens === null || userTokens === void 0 ? void 0 : (_userTokens_ = userTokens[0]) === null || _userTokens_ === void 0 ? void 0 : (_userTokens__ownership = _userTokens_.ownership) === null || _userTokens__ownership === void 0 ? void 0 : _userTokens__ownership.tokenCount) || 0);
    } else {
        var _token_token25, _token_token_owner, _account_address;
        countOwned = (token === null || token === void 0 ? void 0 : (_token_token25 = token.token) === null || _token_token25 === void 0 ? void 0 : (_token_token_owner = _token_token25.owner) === null || _token_token_owner === void 0 ? void 0 : _token_token_owner.toLowerCase()) === (account === null || account === void 0 ? void 0 : (_account_address = account.address) === null || _account_address === void 0 ? void 0 : _account_address.toLowerCase()) ? 1 : 0;
    }
    const isOwner = countOwned > 0;
    const owner = isOwner ? account === null || account === void 0 ? void 0 : account.address : token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.owner;
    const { displayName: ownerFormatted  } = (0,hooks/* useENSResolver */.Af)(token === null || token === void 0 ? void 0 : (_token_token7 = token.token) === null || _token_token7 === void 0 ? void 0 : _token_token7.owner);
    const tokenName = "".concat((token === null || token === void 0 ? void 0 : (_token_token8 = token.token) === null || _token_token8 === void 0 ? void 0 : _token_token8.name) || "#".concat(token === null || token === void 0 ? void 0 : (_token_token9 = token.token) === null || _token_token9 === void 0 ? void 0 : _token_token9.tokenId));
    const hasAttributes = (token === null || token === void 0 ? void 0 : (_token_token10 = token.token) === null || _token_token10 === void 0 ? void 0 : _token_token10.attributes) && (token === null || token === void 0 ? void 0 : (_token_token11 = token.token) === null || _token_token11 === void 0 ? void 0 : _token_token11.attributes.length) > 0;
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
        color: "gray3",
        size: "small",
        css: {
            justifyContent: "space-between",
            width: "336px",
            px: "$2",
            py: "$2"
        },
        children: [
            isSmallDevice ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                style: "body1",
                children: activityNames.map(titleCase/* default */.Z).join(", ") || "All Events"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                css: {
                    color: "$slate10"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons/* faChevronDown */.ptq,
                    width: 16,
                    height: 16
                })
            })
        ]
    });
    (0,react.useEffect)(()=>{
        let tab = tabValue;
        const hasAttributesTab = isMounted && isSmallDevice && hasAttributes;
        if (hasAttributesTab) {
            tab = "attributes";
        } else {
            tab = "info";
        }
        let deeplinkTab = null;
        if (true) {
            const params = new URL(window.location.href).searchParams;
            deeplinkTab = params.get("tab");
        }
        if (deeplinkTab) {
            switch(deeplinkTab){
                case "attributes":
                    if (hasAttributesTab) {
                        tab = "attributes";
                    }
                    break;
                case "info":
                    tab = "info";
                    break;
                case "activity":
                    tab = "activity";
                    break;
                case "listings":
                    tab = "listings";
                    break;
                case "offers":
                    tab = "offers";
                    break;
            }
        }
        setTabValue(tab);
    }, [
        isSmallDevice
    ]);
    (0,react.useEffect)(()=>{
        const updatedUrl = new URL("".concat(window.location.origin).concat(router.asPath));
        updatedUrl.searchParams.set("tab", tabValue);
        router.replace(updatedUrl, undefined, {
            shallow: true
        });
    }, [
        tabValue
    ]);
    const pageTitle = (token === null || token === void 0 ? void 0 : (_token_token12 = token.token) === null || _token_token12 === void 0 ? void 0 : _token_token12.name) ? token.token.name : "".concat(token === null || token === void 0 ? void 0 : (_token_token13 = token.token) === null || _token_token13 === void 0 ? void 0 : _token_token13.tokenId, " - ").concat(token === null || token === void 0 ? void 0 : (_token_token14 = token.token) === null || _token_token14 === void 0 ? void 0 : (_token_token_collection3 = _token_token14.collection) === null || _token_token_collection3 === void 0 ? void 0 : _token_token_collection3.name);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                ogImage: (token === null || token === void 0 ? void 0 : (_token_token15 = token.token) === null || _token_token15 === void 0 ? void 0 : _token_token15.image) || (collection === null || collection === void 0 ? void 0 : collection.banner),
                title: "".concat(pageTitle, " | Birka Brand NFT Marketplace"),
                description: collection === null || collection === void 0 ? void 0 : collection.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                justify: "center",
                css: {
                    maxWidth: 1175,
                    mt: 10,
                    pb: 100,
                    marginLeft: "auto",
                    marginRight: "auto",
                    px: "$1",
                    gap: 20,
                    flexDirection: "column",
                    alignItems: "center",
                    "@md": {
                        mt: 48,
                        px: "$3",
                        flexDirection: "row",
                        gap: 40,
                        alignItems: "flex-start"
                    },
                    "@lg": {
                        gap: 80
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            maxWidth: "100%",
                            flex: 1,
                            width: "100%",
                            "@md": {
                                maxWidth: 445
                            },
                            position: "relative",
                            "@sm": {
                                ">button": {
                                    height: 0,
                                    opacity: 0,
                                    transition: "opacity .3s"
                                }
                            },
                            ":hover >button": {
                                opacity: 1,
                                transition: "opacity .3s"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                css: {
                                    backgroundColor: "$gray3",
                                    borderRadius: 8,
                                    "@sm": {
                                        button: {
                                            height: 0,
                                            opacity: 0,
                                            transition: "opacity .3s"
                                        }
                                    },
                                    ":hover button": {
                                        opacity: 1,
                                        transition: "opacity .3s"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* TokenMedia */.Y1, {
                                        token: token === null || token === void 0 ? void 0 : token.token,
                                        videoOptions: {
                                            autoPlay: true,
                                            muted: true
                                        },
                                        style: {
                                            width: "100%",
                                            height: "auto",
                                            minHeight: isMounted && isSmallDevice ? 300 : 445,
                                            borderRadius: 8,
                                            overflow: "hidden"
                                        },
                                        onRefreshToken: ()=>{
                                            mutate === null || mutate === void 0 ? void 0 : mutate();
                                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                                title: "Refresh token",
                                                description: "Request to refresh this token was accepted."
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(token_FullscreenMedia, {
                                        token: token
                                    })
                                ]
                            }),
                            (token === null || token === void 0 ? void 0 : (_token_token16 = token.token) === null || _token_token16 === void 0 ? void 0 : _token_token16.attributes) && !isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Grid */.rj, {
                                css: {
                                    maxWidth: "100%",
                                    width: "100%",
                                    gridTemplateColumns: "1fr 1fr",
                                    gap: "$3",
                                    mt: 24
                                },
                                children: token === null || token === void 0 ? void 0 : (_token_token17 = token.token) === null || _token_token17 === void 0 ? void 0 : (_token_token_attributes = _token_token17.attributes) === null || _token_token_attributes === void 0 ? void 0 : _token_token_attributes.map((attribute)=>{
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(AttributeCard, {
                                        attribute: attribute,
                                        collectionTokenCount: (collection === null || collection === void 0 ? void 0 : collection.tokenCount) || 0,
                                        collectionId: collection === null || collection === void 0 ? void 0 : collection.id
                                    }, "".concat(attribute.key, "-").concat(attribute.value));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            flex: 1,
                            px: "$3",
                            width: "100%",
                            "@md": {
                                px: 0,
                                maxWidth: "60%",
                                overflow: "hidden"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                justify: "between",
                                align: "center",
                                css: {
                                    mb: 20
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            mr: "$2",
                                            gap: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/".concat(router.query.chain, "/collection/").concat(token === null || token === void 0 ? void 0 : (_token_token18 = token.token) === null || _token_token18 === void 0 ? void 0 : (_token_token_collection4 = _token_token18.collection) === null || _token_token_collection4 === void 0 ? void 0 : _token_token_collection4.id),
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Anchor */.ee, {
                                                    color: "primary",
                                                    css: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "$2"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: free_solid_svg_icons/* faArrowLeft */.acZ,
                                                            height: 16
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                            css: {
                                                                color: "inherit"
                                                            },
                                                            style: "subtitle1",
                                                            ellipsify: true,
                                                            children: token === null || token === void 0 ? void 0 : (_token_token19 = token.token) === null || _token_token19 === void 0 ? void 0 : (_token_token_collection5 = _token_token19.collection) === null || _token_token_collection5 === void 0 ? void 0 : _token_token_collection5.name
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                                openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        onClick: (e)=>{
                                            if (isRefreshing) {
                                                e.preventDefault();
                                                return;
                                            }
                                            setIsRefreshing(true);
                                            (0,fetcher/* default */.ZP)("".concat(window.location.origin, "/").concat(proxyApi, "/tokens/refresh/v1"), undefined, {
                                                method: "POST",
                                                headers: {
                                                    "Content-Type": "application/json"
                                                },
                                                body: JSON.stringify({
                                                    token: "".concat(contract, ":").concat(id)
                                                })
                                            }).then((param)=>{
                                                let { data , response  } = param;
                                                if (response.status === 200) {
                                                    addToast === null || addToast === void 0 ? void 0 : addToast({
                                                        title: "Refresh token",
                                                        description: "Request to refresh this token was accepted."
                                                    });
                                                } else {
                                                    throw data;
                                                }
                                                setIsRefreshing(false);
                                            }).catch((e)=>{
                                                var _DATE_REGEX_exec;
                                                const ratelimit = (_DATE_REGEX_exec = till/* DATE_REGEX.exec */.n.exec(e === null || e === void 0 ? void 0 : e.message)) === null || _DATE_REGEX_exec === void 0 ? void 0 : _DATE_REGEX_exec[0];
                                                addToast === null || addToast === void 0 ? void 0 : addToast({
                                                    title: "Refresh token failed",
                                                    description: ratelimit ? "This token was recently refreshed. The next available refresh is ".concat((0,till/* timeTill */.x)(ratelimit), ".") : "This token was recently refreshed. Please try again later."
                                                });
                                                setIsRefreshing(false);
                                                throw e;
                                            });
                                        },
                                        disabled: isRefreshing,
                                        color: "gray3",
                                        size: "xs",
                                        css: {
                                            cursor: isRefreshing ? "not-allowed" : "pointer"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                            css: {
                                                animation: isRefreshing ? "".concat(LoadingSpinner/* spin */.O, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite") : "none"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faRefresh */.QDM,
                                                width: 16,
                                                height: 16
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                align: "center",
                                css: {
                                    gap: "$2"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "h4",
                                    css: {
                                        wordBreak: "break-all"
                                    },
                                    children: tokenName
                                })
                            }),
                            token && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    is1155 && countOwned > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            mt: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                color: "subtle",
                                                css: {
                                                    mr: "$2"
                                                },
                                                children: [
                                                    "You own ",
                                                    countOwned
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/portfolio",
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                                    color: "primary",
                                                    weight: "normal",
                                                    css: {
                                                        ml: "$1",
                                                        fontSize: 12
                                                    },
                                                    children: "Sell"
                                                })
                                            })
                                        ]
                                    }),
                                    !is1155 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            mt: "$2"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                color: "subtle",
                                                css: {
                                                    mr: "$2"
                                                },
                                                children: "Owner"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((Jazzicon_default()), {
                                                diameter: 16,
                                                seed: (0,react_jazzicon_dist.jsNumberForAddress)(owner || "")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/portfolio/".concat(owner),
                                                legacyBehavior: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                                    color: "primary",
                                                    weight: "normal",
                                                    css: {
                                                        ml: "$1"
                                                    },
                                                    children: isMounted ? ownerFormatted : ""
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RarityRank, {
                                        token: token,
                                        collection: collection,
                                        collectionAttributes: attributesData === null || attributesData === void 0 ? void 0 : attributesData.data
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PriceData, {
                                        token: token
                                    }),
                                    isMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenActions, {
                                        token: token,
                                        offer: offer,
                                        listing: listing,
                                        isOwner: isOwner,
                                        mutate: mutate,
                                        account: account
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
                                        value: tabValue,
                                        onValueChange: (value)=>setTabValue(value),
                                        style: {
                                            paddingRight: isSmallDevice ? 0 : 15
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab/* TabsList */.dr, {
                                                css: {
                                                    overflowX: isSmallDevice ? "scroll" : "unset"
                                                },
                                                children: [
                                                    isMounted && isSmallDevice && hasAttributes && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                        value: "attributes",
                                                        children: "Attributes"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                        value: "info",
                                                        children: "Info"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                        value: "activity",
                                                        children: "Activity"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                        value: "listings",
                                                        children: "Listings"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                                        value: "offers",
                                                        children: "Offers"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "attributes",
                                                children: (token === null || token === void 0 ? void 0 : (_token_token20 = token.token) === null || _token_token20 === void 0 ? void 0 : _token_token20.attributes) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Grid */.rj, {
                                                    css: {
                                                        gap: "$3",
                                                        mt: 24,
                                                        gridTemplateColumns: "1fr",
                                                        "@sm": {
                                                            gridTemplateColumns: "1fr 1fr"
                                                        }
                                                    },
                                                    children: token === null || token === void 0 ? void 0 : (_token_token21 = token.token) === null || _token_token21 === void 0 ? void 0 : (_token_token_attributes1 = _token_token21.attributes) === null || _token_token_attributes1 === void 0 ? void 0 : _token_token_attributes1.map((attribute)=>{
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(AttributeCard, {
                                                            attribute: attribute,
                                                            collectionTokenCount: (collection === null || collection === void 0 ? void 0 : collection.tokenCount) || 0,
                                                            collectionId: collection === null || collection === void 0 ? void 0 : collection.id
                                                        }, "".concat(attribute.key, "-").concat(attribute.value));
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "info",
                                                children: collection && /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenInfo, {
                                                    token: token,
                                                    collection: collection
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab/* TabsContent */.nU, {
                                                value: "activity",
                                                css: {
                                                    mr: -15
                                                },
                                                children: [
                                                    isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileActivityFilters/* MobileActivityFilters */.r, {
                                                        activityTypes: activityTypes,
                                                        setActivityTypes: setActivityTypes
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.Lt, {
                                                        trigger: trigger,
                                                        contentProps: {
                                                            sideOffset: 8
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFilters, {
                                                            open: activityFiltersOpen,
                                                            setOpen: setActivityFiltersOpen,
                                                            activityTypes: activityTypes,
                                                            activityNames: activityNames,
                                                            setActivityNames: setActivityNames,
                                                            setActivityTypes: setActivityTypes
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenActivityTable, {
                                                        id: "".concat(contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token22 = token.token) === null || _token_token22 === void 0 ? void 0 : _token_token22.tokenId),
                                                        activityTypes: activityTypes
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "listings",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListingsTable, {
                                                    token: "".concat(contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token23 = token.token) === null || _token_token23 === void 0 ? void 0 : _token_token23.tokenId),
                                                    address: account.address,
                                                    is1155: is1155,
                                                    isOwner: isOwner
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                                                value: "offers",
                                                css: {
                                                    mr: -15,
                                                    width: "100%"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OffersTable, {
                                                    token: "".concat(contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token24 = token.token) === null || _token_token24 === void 0 ? void 0 : _token_token24.tokenId),
                                                    address: account.address,
                                                    is1155: is1155,
                                                    isOwner: isOwner
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _assetId_ = (IndexPage);


/***/ }),

/***/ 68437:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Convert a word to title case
 * @param word - The word to convert to title case
 * @returns The input word in title case format
 */ function titleCase(word) {
    return word.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (titleCase);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,4946,8957,2659,3985,1943,6143,9774,2888,179], function() { return __webpack_exec__(62812); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);